var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { observer } from "mobx-react";
import { isNil } from "lodash-es";
import { cx } from "emotion";
import FormulaEditor from "@reactivepad/formula-editor";
import { FORMULA_COMPLETION_TYPES } from "../core/common";
import { getFormulaHints, getTablesHints } from "../core/utils";

var FormulaInput = (_temp2 = _class = function (_Component) {
  _inherits(FormulaInput, _Component);

  function FormulaInput() {
    var _temp, _this, _ret;

    _classCallCheck(this, FormulaInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleChange = function (_ref) {
      var doc = _ref.doc;

      var value = doc.text.map(function (t) {
        return t.trim();
      }).join(" ");
      _this.props.onChange(value);
    }, _this.handleKeyDown = function (e) {
      e.stopPropagation();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FormulaInput.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        value = _props.value,
        onSave = _props.onSave,
        className = _props.className,
        wrapperClassName = _props.wrapperClassName,
        style = _props.style,
        store = _props.store;


    var functionsSuggestions = store.functions.map(function (_ref2) {
      var name = _ref2.name,
          description = _ref2.description;
      return {
        name: name,
        insertText: name,
        documentation: description,
        type: FORMULA_COMPLETION_TYPES.function
      };
    });
    var storeSuggestions = [].concat(getFormulaHints(store.formulas, id), getTablesHints(store.tables)).map(function (_ref3) {
      var name = _ref3.name,
          description = _ref3.description,
          type = _ref3.type;
      return {
        name: name,
        insertText: name,
        documentation: description,
        type: type
      };
    });
    var completions = [].concat(storeSuggestions, functionsSuggestions);

    return React.createElement(
      "div",
      {
        id: id,
        className: cx(className, wrapperClassName),
        onKeyDown: this.handleKeyDown
      },
      React.createElement(FormulaEditor, {
        style: _extends({ width: "100%" }, style),
        value: isNil(value) ? "" : "" + value,
        onChange: this.handleChange,
        onSave: onSave,
        completions: completions
      })
    );
  };

  return FormulaInput;
}(Component), _class.defaultProps = {
  value: "",
  onChange: function onChange() {},
  onSave: function onSave() {}
}, _temp2);


export default observer(FormulaInput);